<div class="flex--row flex--nowrap">
  <div class="spacing--margin-right">
    <div class="text--label">
      {{ 'activeIngredientKgPerHa' | translate }}
    </div>
    <div class="flex--row flex--nowrap flex--align-center">
      @if (activeIngredientAmount || activeIngredientAmount === 0) {
        <span class="flex__child--auto">{{ activeIngredientAmount | agrNumber: '1.2-2' }}</span>
      }
      @if (!activeIngredientAmount && activeIngredientAmount !== 0) {
        <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
      }
    </div>
  </div>
</div>
